"use strict";
document.getElementById("form").addEventListener("submit", function(event) {
    event.preventDefault();
    document.getElementById("form").reset();
});

//# sourceMappingURL=index.caf59bb1.js.map
